<script lang="ts">
import { _ } from '../i18n.svelte'
</script>
<template lang="pug">
footer
    .footer__p__text
        | &copy; 2022 
        a.footer__link__text(href="https://twitter.com/tsunezunech" target="_blank" rel="noopener") @tsunezunech
</template>
<style lang="scss">
footer {
    width: 100%;
    height: 5rem;
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    bottom: 0;
    left: 0;
    color: var(--color-white);
    background-color: var(--color-twitter);
    .footer__link__text {
        color: var(--color-white);
    }
}
</style>